<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero" />
    </SectionHero>
    <SectionDefault>
      <Builder :blocks="blocks" :context="{ cityId: 1 }" />
    </SectionDefault>
  </main>
</template>

<script>
import Builder from '../../components/builder/Builder'
import pageBuilder from '../../components/mixins/pageBuilder.js'
import OrganismHero from '../../components/organisms/layouts/OrganismHero'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import SectionHero from '../../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'fitness-testing',
})

export default {
  name: 'FitnessTesting',
  components: {
    SectionDefault,
    SectionHero,
    OrganismHero,
    Builder,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      hero: {
        variant: 'dark-parallax',
        title1: 'Фитнес -',
        title2: 'тестирование',
        imagePosition: '!object-top',
        image: 'fitness/testing/hero.webp',
        imageWrap: 'img-border-0',
        imageMobile: 'fitness/testing/hero-mobile.jpg',
        breadcrumbs: c.$breadcrumbs.fitnessTesting(),
      },
    }
  },
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Service',
            name: 'Фитнес-тестирование',
            description: 'Комплексное тестирование физической подготовки и состава тела.',
            provider: {
              '@type': 'Organization',
              name: 'Encore Fitness',
              url: 'https://encorefitness.ru/',
            },
          },
        },
      ],
    }
  },
}
</script>
